import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';
import { blockedPhoneNumbersRoute } from 'src/app/app-routing.module';
import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { BlockedPhoneNumberPrivileges } from '../models/blocked-phone-number-privileges';
import { BlockedPhoneNumberRegisterOptions } from '../models/blocked-phone-number-register-options';
import { BlockedPhoneNumberRegisterListItem } from '../models/blocked-phone-number-register-results.model';
import { selectQuickFilters } from '../state/blocked-phone-number-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-blocked-phone-number-register-view',
    styleUrls: ['./blocked-phone-number-register-view.component.scss'],
    templateUrl: './blocked-phone-number-register-view.component.html',
    standalone: false
})
export class BlockedPhoneNumberRegisterViewComponent extends EntityRegisterView<
   BlockedPhoneNumberRegisterListItem,
   BlockedPhoneNumberRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() blockedPhoneNumberPrivileges: BlockedPhoneNumberPrivileges;

   @Output() deleteBlockedPhoneNumber = new EventEmitter<{
      blockedPhoneNumberId: number;
      phoneNumber: string;
   }>();

   getRouterLink(id: number) {
      return `/${blockedPhoneNumbersRoute}/${id}`;
   }

   onDeleteClick(blockedPhoneNumberId: number, phoneNumber: string): void {
      this.deleteBlockedPhoneNumber.emit({
         blockedPhoneNumberId: blockedPhoneNumberId,
         phoneNumber: phoneNumber ?? '',
      });
   }
}
